import { theme } from "@bleu/front/assets/theme"
import { router } from "@bleu/front/pages/router"
import { ChakraBaseProvider } from "@chakra-ui/react"
import dayjs from "dayjs"
import "dayjs/locale/fr"
import LocalizedFormat from "dayjs/plugin/localizedFormat"
import { ErrorBoundary } from "react-error-boundary"
import { RouterProvider } from "react-router-dom"
import { ErrorBoundaryFallback } from "./ErrorBoundaryFallback"
import "./global.css"

dayjs.extend(LocalizedFormat)
dayjs.locale("fr")

function App() {
  return (
    <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
      <ChakraBaseProvider theme={theme}>
        <RouterProvider router={router} />
      </ChakraBaseProvider>
    </ErrorBoundary>
  )
}

export default App
